import {
  GET_NOCONFORMIDADES_REQUEST,
  GET_NOCONFORMIDADES_SUCCESS,
  SELECCIONAR_NO_CONFORMIDAD,
  GET_NOCONFORMIDAD_REQUEST,
  CREATE_NOCONFORMIDAD_REQUEST,
  SET_MOSTRAR_BOTON_GUARDAR,
  SET_MOSTRAR_BOTON_TIPOLOGIAS,
  SET_ACTIVE_TAB_FORM,
  GET_NOCONFORMIDAD_SUCCESS,
  UPDATE_NOCONFORMIDAD_REQUEST,
  RESET_NO_CONFORMIDADES,
  NO_CONFORMIDAD_DESELECT,
  SET_MOSTRAR_BOTON_AFECTADOS,
  DELETE_PHOTO_NOCONFORMIDAD_REQUEST,
  SET_MOSTRAR_BARRA_BOTONES_FORM_NC,
} from '../../actions/constants/noconformidades/noconformidades.constants';

const initialState = {
  loading: false,
  listado: [],
  esListadoFiltrado: false,
  total: 0,
  page: 1,
  start: 0,
  limit: 25,
  seleccionada: {},
  totalNcVencidas: 0,
  totalNcConAcciones: 0,
  totalNcActivas: 0,
  form: null,
  mostrarGuardarNc: true,
  mostrarBotonTipologiasNc: true,
  mostrarBotonAfectadosNc: true,
  mostrarBotonBarraBotonesFormNc: true,
  activeTabFormNc: '1',
  resultado: null,
};

export default function noConformidadesReducer(state = initialState, { type, payload }) {
  switch (type) {
    case RESET_NO_CONFORMIDADES: {
      return {
        ...state, seleccionada: {}, page: 1, start: 0, total: 25, listado: [], esListadoFiltrado: false,
      };
    }
    case GET_NOCONFORMIDADES_REQUEST: {
      return {
        ...state, loading: true,
      };
    }

    case GET_NOCONFORMIDAD_REQUEST: {
      return {
        ...state, seleccionada: { loading: true },
      };
    }

    case GET_NOCONFORMIDADES_SUCCESS: {
      const {
        datos, total, page, start, limit, esListadoFiltrado,
      } = payload;
      const { listado } = state;

      const newListado = [...listado, ...datos];

      const newListadoConAcciones = newListado.filter(({ color_estado: colorEstado }) => colorEstado === 'green');
      const newListadoVencidas = newListado.filter(({ color_estado: colorEstado }) => colorEstado === 'red');
      const newListadoActivas = newListado.filter(({ color_estado: colorEstado }) => colorEstado !== 'green' && colorEstado !== 'red');

      const totalNcConAcciones = newListadoConAcciones.length;
      const totalNcVencidas = newListadoVencidas.length;
      const totalNcActivas = newListadoActivas.length;

      return {
        ...state, listado: newListado, total, loading: false, page, start, limit, totalNcVencidas, totalNcConAcciones, totalNcActivas, esListadoFiltrado,
      };
    }

    case SELECCIONAR_NO_CONFORMIDAD: {
      const { seleccionada } = payload;
      return {
        ...state, seleccionada,
      };
    }

    case CREATE_NOCONFORMIDAD_REQUEST: {
      const { form } = payload;
      return {
        ...state, form,
      };
    }

    case SET_MOSTRAR_BOTON_GUARDAR: {
      const { mostrarGuardarNc } = payload;
      return {
        ...state, mostrarGuardarNc,
      };
    }

    case SET_MOSTRAR_BOTON_TIPOLOGIAS: {
      const { mostrarBotonTipologiasNc } = payload;
      return {
        ...state, mostrarBotonTipologiasNc,
      };
    }

    case SET_MOSTRAR_BOTON_AFECTADOS: {
      const { mostrarBotonAfectadosNc } = payload;
      return {
        ...state, mostrarBotonAfectadosNc,
      };
    }

    case SET_ACTIVE_TAB_FORM: {
      const { activeTabFormNc } = payload;
      return {
        ...state, activeTabFormNc,
      };
    }

    case GET_NOCONFORMIDAD_SUCCESS: {
      const { resultado } = payload;
      return {
        ...state, resultado,
      };
    }

    case UPDATE_NOCONFORMIDAD_REQUEST: {
      const { form } = payload;
      return {
        ...state, form,
      };
    }

    case NO_CONFORMIDAD_DESELECT: {
      return {
        ...state, seleccionada: {},
      };
    }

    case DELETE_PHOTO_NOCONFORMIDAD_REQUEST: {
      const { form } = payload;
      return {
        ...state, form,
      };
    }

    case SET_MOSTRAR_BARRA_BOTONES_FORM_NC: {
      const { mostrarBotonBarraBotonesFormNc } = payload;
      return {
        ...state, mostrarBotonBarraBotonesFormNc,
      };
    }

    default:
      return state;
  }
}
